import React, {useEffect, useRef, useState} from 'react'
import {useDispatch, useSelector} from "react-redux";
import Button from "../Button";
import ModalWindow from "../ModalWindow";
import {setPreviewData, setShowPreviewPanel, toggleShowFeedbackModalVisibility} from "../../../actions/ui";
import './FeedbackModal.scss'
import axios from "axios";
import {CSRF} from "../../../constants";

const FeedbackModal = (props) => {
  const dispatch = useDispatch()
  const showFeedbackModal = useSelector(state => state.ui.showFeedbackModal)
  const feedbackText = useRef()
  const [formRes, setFormRes] = useState(false)


  const handleFormSubmit = (e) => {
    e.preventDefault()
    if(formRes){
      dispatch(toggleShowFeedbackModalVisibility())
      setFormRes(false)
    }else{
      const formData = new FormData()
      formData.append("feedback", feedbackText.current.value)
      axios({
        method: 'post',
        url: `/main/send_feedback`,
        data: formData,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': CSRF
        }
      }).then(response => {
        setFormRes(true)
      }).catch(error => {
            setFormRes(false)
          }
      )
    }
  }

  const closeFeedbackForm = (e) => {
    dispatch(toggleShowFeedbackModalVisibility())
    setFormRes(false)
  }

  return (
    <>
      {showFeedbackModal && (<ModalWindow
          header={"Share your feedback"}
          closeHandler={closeFeedbackForm}
          toTop={true}
      >
        <form onSubmit={handleFormSubmit} >

          {formRes ? <>
            <div className="mb-3">
              Thanks for sharing your feedback!
            </div>
          </> : <>
            <div className="mb-3">
              We believe that great products are built with the help and insights of users.
            </div>

            <div className="mb-4">
              That’s why we’ve created this place for you to share your feedback, suggestions, and feature requests. We
              look forward to hearing your honest and unfiltered thoughts 💭
            </div>

            <div className="form-group mb-3">
              <textarea
                  className="form-control faq-textarea"
                  name="feedback"
                  rows="5"
                  ref={feedbackText}
                  required
              />
            </div>
          </>}

          <div className="d-flex justify-content-end mt-4">
            <Button className="btn btn-primary" type="submit">
              {formRes ? 'Close' : 'Submit your feedback'}
            </Button>
          </div>
        </form>
      </ModalWindow>)}

    </>
  )
}

export default React.memo(FeedbackModal)